import { type Result, ResultStatus } from '@carvana/merch-result';
import { axios } from '~/clients';
import { Article } from '~/contracts/flp';
import ErrorWithContext from '~/utilities/ErrorWithContext';
import { getQueryParameterFilters } from '~/utilities/flp/getQueryParameterFilters';
import { logError } from '~/utilities/loggers';

/**
 * Retrieve Articles from Strapi CMS with optional Article URL Field filtering. If no URLs are provided, all articles are retrieved.
 * @param urls
 */
export default async function getArticles(
  urls?: string[]
): Promise<Result<Article[]>> {
  const query = urls ? `?${getQueryParameterFilters('article_url', urls)}` : '';
  try {
    const res = await axios.get(
      `${process.env.CVNA_APIK_BASE_URL}/core/strapicms/api/articles${query}`
    );

    return {
      content: res.data.data.map((d: { attributes: Article }) => d.attributes),
      status: ResultStatus.Succeeded
    };
  } catch (err) {
    const message = 'Failed to retrieve articles.';
    logError(new ErrorWithContext(err, { message }));

    return {
      errorMessage: message,
      status: ResultStatus.ProcessingError
    };
  }
}
